module.exports = __webpack_public_path__ + "static/img/logo.9d4c9119.svg";